import React from "react";
import Text from "components/ui/Text";
import { Switcher } from "components/ui/Switcher";
import { BizInfoContainer, BizInfoWrap, BizButtonContainer, BizPackAndShopImage } from "./BizContainer";

interface BizItemRowProps {
  iconSrc: string;
  iconAlt: string;
  title: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  switcherColor?: "default" | "primary" | "success";
  size?: "sm" | "md" | "lg";
}

export const BizItemRow: React.FC<BizItemRowProps> = ({
  iconSrc,
  iconAlt,
  title,
  checked,
  onChange,
  switcherColor = "primary",
  size = "md",
}) => {
  return (
    <BizInfoContainer>
      <BizInfoWrap>
        <BizPackAndShopImage src={iconSrc} alt={iconAlt} />
        <Text fontSize={17} fontWeight={600} color="#1A1A1E">
          {title}
        </Text>
      </BizInfoWrap>

      <BizButtonContainer>
        <Switcher switcherColor={switcherColor} size={size} checked={checked} onChange={() => onChange(!checked)} />
      </BizButtonContainer>
    </BizInfoContainer>
  );
};
